import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, CardActions } from '@mui/material';
import { FormActionsProps } from '@pages/SavingsCalculator/types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

const FormActions = ({
  values,
  calculateSavings,
  resetFormState,
}: FormActionsProps) => {
  const { t } = useTranslation();
  const isDisabled = !values.step1 || !values.step2 || !values.step3;
  return (
    <CardActions className="!px-12 !pt-0 !pb-5">
      <Button
        variant="outlined"
        className={clsx(
          isDisabled
            ? '!border-[#C6C6C6] !text-[#C6C6C6]'
            : '!border-[#006BF8] !text-[#006BF8]'
        )}
        onClick={resetFormState}
        disabled={isDisabled}
      >
        <RefreshIcon />
      </Button>
      <Button
        className={clsx(
          '!text-white',
          isDisabled ? '!bg-[#C6C6C6]' : '!bg-[#006BF8]'
        )}
        variant="contained"
        onClick={calculateSavings}
        disabled={isDisabled}
      >
        {t('svngsAction')}
      </Button>
    </CardActions>
  );
};

export default FormActions;
